<template lang="pug">
md-layout(md-flex='100')
    md-layout#help-icon(@mouseover.native="showInstructions", @mouseout.native="hideInstructions")
        md-icon(md-iconset="fa fa-info-circle")
    div.help-alert(v-if="isAlertVisible")
        p If you change the playlist, this may cause changes in the Categories, please review them before Updating
    md-layout(md-align='center').md-headline Sections
    edit-or-new-section(ref="popUpSection", @currentsections='currentSections', :entity='entity', :playlist-items='playlistItems')

    md-layout(md-flex='100')
        SlickList.container-sections(md-align='center', v-model="entity.sections", :class="{'sections-list': loading}")
            Loader(:loading='loading', class='loader-icon')
            SlickItem.sections(v-for='(section, index) in entity.sections', :key='section.name', :index='index', :class="{ 'disabled-section': !section.visible, 'most-popular-section': isMostPopular(section) }")
                div.info-section
                    div.titleMenu
                        h3.title-section  {{ index+1 }} - {{ section.name }}
                        p.title-section(v-if='section.type === "playlist"' :class="{ 'series-section': section.type === 'playlist' }") Series
                        md-icon.md-icon.icon-warning(md-iconset="fa fa-exclamation-triangle", v-if="hasProblem(section)")
                            md-tooltip.tooltip-warning() Some series in this section do not exist in the current playlist
                    div.info-btn-section
                        p.statusInfo(:class="{ 'live-status': section.visible }") {{ section.visible ? 'LIVE' : 'DRAFT' }}
                        md-switch(v-model='section.visible')
                        md-button#btn.md-icon-button(@click='removeSection(index, section.name)' :disabled='isMostPopular(section)')
                            md-icon#md-icon-section(md-iconset="fa fa-trash-alt" :class="{ 'disabled-icon': isMostPopular(section) }")
                        md-button#btn.md-icon-button(@click='editSection(index, section)')
                            md-icon#md-icon-section(md-iconset="fa fa-pencil-alt")

                div.sectContainer(v-if="section.type !=='playlist'")
                    p.sect(v-for='section in section.tagsAssociated') {{ section }}
                div.sectContainer(v-else)
                    p.sect(v-for='section in section.seriesAssociated') {{ section.name ? section.name : associatedSeries.filter((serie) => serie._id === section)[0].name }}
            div
                md-button.md-primary.md-raised(@click.native='addNewSection') Add Section

</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort';
import playlistService from '../../../services/playlistService';
import EditOrNewSection from './EditOrNewSection';
import Loader from '../../Loader';


    export default {
    components: {
        SlickItem,
        SlickList,
        EditOrNewSection,
        Loader
    },
    props: {
        entity: {
        type: Object,
        required: true
        },
        playlistItems: {
        type: Array,
        default: () => []
        }
    },
    data() {
        return {
        title:'',
        tag:'',
        newSection: false,
        visible: true,
        associatedSeries: [],
        seriesAssociated: [],
        isEdit: false,
        isAlertVisible: false,
        loading: false,
        };
    },
    methods: {
        removeSection(index, name) {
            this.$swal.fire({
            html: `<h4>Delete section:</h4> <h3>${name}</h3>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            }).then(res => {
                if (res.isConfirmed) {
                    this.entity.sections.splice(index, 1);
                }
                document.body.style.overflow = '';
            });
        },
        editSection(index, section){
            this.$refs.popUpSection.openEditDialog(index, section, this.associatedSeries,  )
        },
        addNewSection(){
            this.$refs.popUpSection.openAddDialog(this.associatedSeries)
            this.newSection = true;
        },
        currentSections(){
            this.$emit('currentsections', this.entity.sections)
        },
        getAssociatedSeries(){
            if(!this.entity.source.playlist) return;
            playlistService.get(this.entity.source.playlist)
            .then(res => {
                this.associatedSeries = res.data.associatedSeries;
            })
        },
        hasProblem(section) {
            if(section.seriesAssociated && section.seriesAssociated.length > 0) {
                const sectionSeriesIds = section.seriesAssociated.map(series => typeof(series) === 'object' ? series._id : series);
                const associatedSeriesIds = this.associatedSeries.map(series => series._id);
                return sectionSeriesIds.some(id => !associatedSeriesIds.includes(id));
            }
        },
        showInstructions() {
            this.isAlertVisible = true;
        },
        hideInstructions() {
            this.isAlertVisible = false;
        },
        isMostPopular(section) {
            const mostPopularRegex = /^(most\s+popular|mostpopular)$/i;

            return section.name && mostPopularRegex.test(section.name.trim());
        }
    },
    mounted() {
    },
    created() {
        setTimeout(() => {
            this.getAssociatedSeries();
        }, 3000);
    },
    watch: {
        'entity.source.playlist': {
            handler() {
                this.getAssociatedSeries()
            },
                deep: true,
            },
            'entity.sections': {
                handler(sections) {
                    const visibleSections = sections.filter(section => section.visible);
                    const hiddenSections = sections.filter(section => !section.visible);
                    const reorderedSections = [...visibleSections, ...hiddenSections];
                    if (JSON.stringify(reorderedSections) !== JSON.stringify(this.entity.sections)) {
                        this.loading = true;
                        setTimeout(() => {
                            this.entity.sections = reorderedSections;
                            this.loading = false;
                        }, 500);
                    }
                },
                deep: true,
            },
        }
    };
</script>

<style lang="scss">
.md-dialog{
    width: 70% ;
    border-radius: 6px;
}
.loader-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.sections-list{
    opacity: .3;
}
.container-sections{
    width: 100%;
    display: flex;
    padding: 5px;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
}
.sections{
    width: 800px;
    padding: 3px;
    margin: 5px;
    border-radius: 6px;
    box-shadow: 2px 2px 10px #dfdfdf;
}
.most-popular-section {
    background: repeating-linear-gradient(
        45deg,
        #f8f8f8,
        #f8f8f8 10px,
        #79797930 10px,
        #79797930 20px
    )
}
#btn{
    background-color: transparent !important;
}
#btn:hover{
    background-color: transparent !important;
}
.live-status{
    color: rgba(0, 128, 0, 0.63);
    font-weight: bold;
}
#md-icon-section{
    color: #4b4b4b !important;
    font-size: 18px;
    margin-top: 13px;
    transition: all 0.3s ease-in-out;
}
#md-icon-section:hover{
    transform: scale(1.2);
    color: #d11a2a !important;
}
.info-section{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.info-btn-section{
    display: flex;
    align-items: center;
}
.statusInfo{
    margin-right: 10px;
}
.radioButtons-section{
    width: 100%;
    margin-bottom: 15px;
}
.sectContainer{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.sect{
    padding: 5px;
    margin: 5px;
    border-radius: 6px;
    background-color: #94ccd9;
    width: fit-content;
    color: #fff;
}
.titleMenu{
    display: flex;
    align-items: center;
}
.title-section{
    margin: 0 10px;
    color: gray;
}
.disabled-section {
    transition: opacity 1s ease-in-out;
    opacity: 0.5;
    &:not{
        opacity: 1;
    }
}
.disabled-icon {
    opacity: 0.5;
    color: #dfdfdf !important;
}
.series-section {
    padding: 2px 7px;
    color: #f1f1f1;
    font-weight: bold;
    background-color: #bc1f4a;
    border-radius: 4px;
}
.icon-warning{
    margin-left: 5px;
    margin-right: 15px;
    color: darkorange !important;
}
.tooltip-warning {
    background-color: darkorange;
    color: #fff;
    font-size: 11px;
    border-radius: 4px;
    font-weight: bold;
}

#help-icon {
    position: absolute;
    right: 20px;
    cursor: pointer;
    i{
        color: #f6af16 !important;
        font-size: 24px;
    }
}

.help-alert {
    position: absolute;
    right: 10px;
    top: 55px;
    padding: 4px 8px;
    background-color: rgb(244, 244, 244);
    border-radius: 5px;
    max-width: 300px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 9;
}
.help-alert p{
    margin: 5px;
    margin-right: 5px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/Sections.vue